import { TableContent, TableContentWithoutEditDateFromat } from '../../../Common/Table/tableContent';
import React from "react";
import tokenService from '../../../../Common/tokenDecoder';

export default class ComponentToPrint extends React.Component {
    render() {

        const data = this.props.data;
        const rowNames = this.props.rowNames;
        const searchData = this.props.searchData;
        const totalRow = this.props.totalRow;
        const columeNames = this.props.columeNames;

        return (
            <div>
                <h3><center><u>Supplier Dairy Summary Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Factory: </b> {searchData.estate}</div>
                    <div className="col"><b>Collection Point: </b> {searchData.collectionID}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                    <div className="col"><b>Date/Time: </b> {new Date().toLocaleString()}</div>
                </div>
                <table id="totalCropPdf">
                    <thead>
                        <tr>
                            <th style={{ fontWeight: "bold" }} rowSpan="2">Division</th>
                            <th style={{ fontWeight: "bold" }} rowSpan="2">Employee Code</th>
                            <th style={{ fontWeight: "bold" }} rowSpan="2">Reg No</th>
                            <th style={{ fontWeight: "bold" }} rowSpan="2">EPF No</th>
                            <th style={{ fontWeight: "bold" }} rowSpan="2">Name</th>
                            <th style={{ fontWeight: "bold" }} rowSpan="2">NIC</th>
                            <th style={{ fontWeight: "bold" }} rowSpan="2">Card Number</th>
                            <th style={{ fontWeight: "bold" }} rowSpan="2">Job List</th>
                            <th style={{ fontWeight: "bold" }} rowSpan="2">Card Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.map((row, index) => (
                            <>
                                <tr>
                                    <td>{row.collectionPointName}</td>
                                    <td>{row.employeeCode}</td>
                                    <td>{row.registrationNumber}</td>
                                    <td>{row.epfNo}</td>
                                    <td>{row.firstName}</td>
                                    <td style={{ textAlign: "right" }}>{row.nic}</td>
                                    <td style={{ textAlign: "right" }}>{row.cardNumber}</td>
                                    <td style={{ textAlign: "right" }}>
                                    {row.jobTypeList.map((i) => (
                                        i.haverstingJobTypeName + ", "
                                    ))}
                                    </td>
                                    <td style={{ textAlign: "right" }}>{row.cardStatusDescription}</td>
                                </tr>
                            </>
                        ))}
                    </tbody>
                </table>
                <hr />
            </div>
        );
    }
}